module.exports = __webpack_public_path__ + "89b1b347a79f99e8a16bcb7da3e1a01b.png";